<template>
  <div style="width: 100%;height: 100%;">
    <!--JPG与3D的缩略-->
    <image-layer ref="imageLayer" v-if="layerType === 1 || layerType === 2"></image-layer>
    <!--垂直卷帘-->
    <compare-vertical ref="vertical" v-if="layerType === 3 && compareMode === 'vertical'" :bottom-layer-cite="bottomLayerCite" :top-layer-cite="topLayerCite" :bounds="bounds"
                      :compare_layer-full-screen = false></compare-vertical>
    <!--水平卷帘-->
    <compare-horizontal ref="horizontal" v-if="layerType === 3 && compareMode === 'horizontal'" :bottom-layer-cite="bottomLayerCite" :top-layer-cite="topLayerCite" :bounds="bounds" :compare_layer-full-screen = false></compare-horizontal>
  </div>
</template>

<script>
import ImageLayer from "@/components/image_details/image_layer/ImageLayer";
import CompareVertical from "@/components/image_details/compare_layer/CompareVertical";
import CompareHorizontal from "@/components/image_details/compare_layer/CompareHorizontal";

export default {
  mounted() {
    window.addEventListener("resize", () => { // 监听浏览器窗口大小改变
      // 浏览器变化执行动作
      if(this.layerType === 3){
        this.layerType = -1
        this.$nextTick(()=>{
          this.layerType = 3
        })
      }
    });
  },
  name: "ImageDetail",
  components: {
    CompareHorizontal,
    CompareVertical,
    ImageLayer
  },
  props:{
    changeLayer: {
      type: Function,
      default: null
    },
  },
  data(){
    return {
      // compareMode:'vertical',
      compareMode:'horizontal',
      layerType:-1000,
      cite:'',
      bounds:'',
      bottomLayerCite:'',
      topLayerCite:'',
    }
  },
  methods:{
    updateImageLayers(material){
      if(material.type === 1){
        //JPG
        this.layerType = material.type
        this.$nextTick(()=>{
          this.$refs.imageLayer.updatedLayer(material.cite,material.geo)
        })
      }else if(material.type === 2){
        //3D
        this.layerType = material.type
        this.$nextTick(()=>{
          this.$refs.imageLayer.updatedLayer(material.cite,material.geo)
        })
      }else{
        //卷帘
        this.bottomLayerCite = material.cite
        this.topLayerCite = material.compareCite
        this.bounds = material.compareGeo
      }
      this.layerType = material.type
    },
    zoomIn(){
      if(this.layerType === 1 || this.layerType === 2){
        this.$refs.imageLayer.zoomIn()
      }else{
        if(this.compareMode === 'vertical'){
          this.$refs.vertical.zoomIn()
        }else{
          this.$refs.horizontal.zoomIn()
        }
      }
    },
    zoomOut(){
      if(this.layerType === 1 || this.layerType === 2){
        this.$refs.imageLayer.zoomOut()
      }else{
        if(this.compareMode === 'vertical'){
          this.$refs.vertical.zoomOut()
        }else{
          this.$refs.horizontal.zoomOut()
        }
      }    },
    changeCompareMode(){
      if(this.compareMode === 'vertical'){
        this.compareMode = 'horizontal'
      }else{
        this.compareMode = 'vertical'
      }
      localStorage.setItem("tempCompareMode",this.compareMode);
    }
  }
}
</script>

<style scoped>

</style>